import { Moon, Sun } from 'lucide-react'

import { useTheme } from 'src/hooks/useTheme'

import { THEME_OPTIONS } from 'src/features/ThemeModeSwitcher/constants'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuContent,
} from 'src/components/shadcn/dropdown-menu'
import { Button } from 'src/components/shadcn/button'

export function ThemeModeSwitcher() {
  const { handleSetTheme } = useTheme()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="w-9 h-9 rounded-[8px]">
          <Sun className="absolute h-[2rem] w-[2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-[2rem] w-[2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {THEME_OPTIONS.map(theme => (
          <DropdownMenuItem
            className="capitalize"
            key={theme}
            onClick={() => handleSetTheme(theme)}
          >
            {theme}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
